export const POSITION_REVERSE_MAP = {
  left: 'right',
  right: 'left',
};
